<template>
  <div>
    <component :is="errorPage" :error="error" />
  </div>
</template>

<script>
export default {
  name: 'NuxtError',
  middleware: [], // No auth middleware for error pages
  components: {
    Error404: () => import('@/components/core/404'),
  },
  props: {
    error: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    errorPage() {
      return this.Error404
    },
  },
}
</script>
